<h3>Banners</h3>
<div [formGroup]="parentFormGroup">
  <div class="row-wrap">
    <button type="button" mat-button (click)="addNewBanner($event)"><mat-icon>add</mat-icon> Add Banner</button>
    @if (containsExpiredBanners) {
      <div>
        <button type="button" mat-raised-button color="primary" (click)="deleteExpiredBanners($event)">Delete expired banners</button>
      </div>
    }
  </div>
  <div formArrayName="items" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (config of bannersConfig.items ; track config; let i = $index) {
      <div cdkDrag>
        <div class="banner-configuration" [formGroupName]="i">
          <div class="icons-wrap">
            <span class="drag-handle" cdkDragHandle>
              <mat-icon>drag_indicator</mat-icon>
            </span>
            @if (isBannerFormExpired(i)) {
              <span class="warning-icon">
                <mat-icon matTooltip="This banner is expired">warning</mat-icon>
              </span>
            }
          </div>
          <banner-config [bannerConfig]="config" (deleteBannerClicked)="deleteBanner($event)"
            [parentFormGroup]="getFormGroup(i)">
          </banner-config>
        </div>
      </div>
    }
  </div>
</div>
